import { Component, OnInit, Input, HostListener, Output, EventEmitter, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Module } from 'src/app/interfaces/module.interface';
import { AnimationService } from 'src/app/services/animation.service';
import { PageService } from 'src/app/services/page.service';
import { RelatedService } from 'src/app/services/related.service';
import { BannerModuleVideoComponent } from '../banner-module-video/banner-module-video.component';
@Component({
    selector: 'app-banner-module',
    templateUrl: './banner-module.component.html',
    styleUrls: ['./banner-module.component.scss']
})
export class BannerModuleComponent implements OnInit, AfterViewInit {
    @Input() module: Module;
    @Input() title: string;
    @Input() subtitle: string;
    @Input() i: number;
    @Input() counter: number;
    @Input() slug: string;
    photoGallery: any;
    galleryItemActive: number;
    screenHeight: number;
    screenWidth: number;
    interval;
    videotitleActive: boolean = false;
    videocontentActive: boolean = false;
    pauselisder: boolean = true;
    getStorageImage: string;
    getStorageTextColor: string;
    setOverlayActive: boolean = false;
    returncolorvalue: string;
    returnbuttoncolorvalue: string;
    menucheckactive = true;
    logocheckactive = true;
    stopbackgroundcheck: boolean = false;
    imageIsLoaded: boolean = false;
    animationSub: Subscription;
    randomImage: string;
    width: number = 0;
    labelwidth: number = 0;
    isNotPaused: boolean = true;
    projectIsLoaded = false;
    activateBannerVideo: boolean = false;
    playVideoButton: boolean = true;
    videoStarted: boolean = false;
    bannerMode;
    main = document.getElementsByClassName('main')[0];
    postColor;
    videoPlaying: boolean = false;
    disableTitleAnimation: boolean = false;
    timer: any;
    fadeInBuffer: boolean = false;
    @Output() returnIndexItem: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('videoitem') videoitem: BannerModuleVideoComponent;
    public returnIndexData = {
        index: null,
        slug: null,
    }
    
    constructor(private animationService: AnimationService,
        private router: Router,
        private related: RelatedService,
        private pageService: PageService) {
        this.animationSub = this.animationService.returnInitEventOnHeader().subscribe(() => {
            this.resetIndexReturn();
            setTimeout(() => {
                this.setImageOverlayModule();
            }, 100);
        });
        this.pageService.mobileVideoPlayingListen().subscribe((resp) => {
            this.videoPlaying = resp;
        })

        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        if (window.location.host === event.srcElement.location.host) {
            this.resetIndexReturn();
        }
    }

    resetIndexReturn() {
        this.disableTitleAnimation = false;
        this.videocontentActive = false;
        this.videotitleActive = false;
        this.returnIndexData.index = this.galleryItemActive;
        this.returnIndexData.slug = this.slug;
        this.animationService.animationIndexOnReturn(this.returnIndexData);
    }

    ngOnInit() {
        if (this.screenWidth > 1024) {
            this.labelwidth = 120 / this.module.banner_gallery.length;
        } else {
            this.labelwidth = 40;
        }
        this.interval = setInterval(() => {
            if (this.isNotPaused) {
                if (this.width >= 100) {
                    this.width = 0;
                    this.nextImage();
                } else {
                    this.width++;
                }
            }
        }, 150);
        this.animationService.returnanimationimageindex.subscribe(index => {
            if (index != null && this.i == 0) {
                this.galleryItemActive = index;
            } else {
                this.galleryItemActive = 0;
            }
        });
        this.randomImage = this.module.banner_gallery[Math.floor(Math.random() * this.module.banner_gallery.length)].banner_item;
        this.contentActive();
        this.getStorageTextColor = this.module.banner_gallery[this.galleryItemActive].title_and_subtitle_color;
        this.postFadeColor(this.getStorageTextColor);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.projectIsLoaded = true;
            setTimeout(() => {
                this.disableTitleAnimation = true;
            }, 2000);
        }, 1000);
    }

    ngOnDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        if (this.animationSub) {
            this.animationSub.unsubscribe();
        }
    }

    contentActive() {
        setTimeout(() => {
            this.videotitleActive = true;
            setTimeout(() => {
                this.videocontentActive = true;
            }, 150);
        }, 150);
        this.pauselisder = true;
    }

    contentDisable() {
        setTimeout(() => {
            setTimeout(() => {
                this.videocontentActive = false;
            }, 150);
            this.videotitleActive = false;
        }, 150);
        this.pauselisder = false;
    }

    nextImage() {
        if (this.pauselisder == true) {
            if (this.module.banner_gallery.length === this.galleryItemActive + 1) {
                this.galleryItemActive = 0;
            } else {
                this.galleryItemActive++;
            }
            this.returnbuttoncolorvalue = this.module.banner_gallery[this.galleryItemActive].title_and_subtitle_color;
            this.getStorageTextColor = this.module.banner_gallery[this.galleryItemActive].title_and_subtitle_color;
            this.postFadeColor(this.getStorageTextColor);
        }
    }

    setImageOverlayModule() {
        if (this.counter === 0) {
            this.router.navigate(['/works']);
        } else {
            this.getStorageImage = this.module.banner_gallery[this.galleryItemActive].banner_item;
            this.getStorageTextColor = this.module.banner_gallery[this.galleryItemActive].title_and_subtitle_color;
            this.postFadeColor(this.getStorageTextColor);
            this.setOverlayActive = true;
            setTimeout(() => {
                this.router.navigate(['/works']);
            }, 300);
        }
    }

    activeSlide(i) {
        this.width = 0;
        this.galleryItemActive = i;
        if (this.galleryItemActive >= this.module.banner_gallery.length) {
            this.galleryItemActive = 0;
        }
        if (this.galleryItemActive < 0) {
            this.galleryItemActive = this.module.banner_gallery.length - 1;
        }
        this.postFadeColor(this.module.banner_gallery[this.galleryItemActive].title_and_subtitle_color);
    }

    onSwipeLeft() {
        if (this.screenWidth <= 1024) {
            var nextSlide = this.galleryItemActive + 1;
            this.activeSlide(nextSlide);
        }
    }

    onSwipeRight() {
        if (this.screenWidth <= 1024) {
            var prevSlide = this.galleryItemActive - 1;
            this.activeSlide(prevSlide);
        }
    }

    isLoaded() {
        this.imageIsLoaded = true;
        this.related.removeOverlay();
    }

    textCheckFunction(brightness) {
        if (brightness < 127.5) {
            this.returncolorvalue = 'f-white';
        } else {
            this.returncolorvalue = 'f-darker';
        }
    }

    buttonCheckFunction(brightness) {
        if (brightness < 127.5) {
            this.returnbuttoncolorvalue = 'f-white';
        } else {
            this.returnbuttoncolorvalue = 'f-darker';
        }
    }

    activateBannerModule() {
        if (this.videoStarted && !this.playVideoButton) {
            this.videoitem.pause();
        }
        if (this.videoStarted && this.playVideoButton) {
            this.videoitem.play();
        }

        this.playVideoButton = !this.playVideoButton;

        if (!this.videoStarted) {
            this.videoitem.activeVideo();
            clearInterval(this.interval);
            this.videoStarted = true;
        }
    }

    postFadeColor(textColor) {
        if (textColor == "white") {
            this.postColor = "#222222";
            this.bannerMode = "dark";
        } else {
            this.postColor = "#fafafa";
            this.bannerMode = "light";
        }
    }

    onMouseMove(e) {
        var cursor = document.getElementsByClassName('cursor')[0];
        cursor.classList.add('active');
        var top = e.pageY;
        var left = e.pageX;
        cursor.setAttribute("style", "top: " + top + "px; left: " + left + "px;");

        if (this.videoStarted) {
            if (!this.fadeInBuffer) {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = 0;
                }
                if (cursor.classList.contains('hide-cursor')) {
                    cursor.classList.remove('hide-cursor');
                }
            } else {
                this.fadeInBuffer = false;
            }

            this.timer = setTimeout(function () {
                cursor.classList.add('hide-cursor');
                this.fadeInBuffer = true;
            }, 1000)
        }
    }

    onMouseOut() {
        var cursor = document.getElementsByClassName('cursor')[0];
        cursor.classList.remove('active');
    }
    
    resetButton() {
        this.playVideoButton = true;
    }
}
